module.exports = __webpack_public_path__ + "img/jifenduihuan_entrance11.a184d12a.png";